import React, { Component } from 'react';
import { Panel, Alert } from 'react-bootstrap';
import Loader from 'src/js/Loader.js';
import { Bar } from 'react-chartjs-2';
import { msgs } from 'src/js/ErrorMessage.js';
import 'src/i18n';
import { withTranslation} from 'react-i18next';

class EventGraph extends Component {
  constructor() {
    super();
  }

  setBarColor(){
    const from = this.props.eventPeriodFrom;
    const to = this.props.eventPeriodTo;
    let colorList = [];
    for (let i = 0; i < 24; i++) {
      if(from <= i && i <= to){
        colorList.push("rgba(57,57,205,0.8)");
      }else{
        colorList.push("rgba(57,57,205,0.3)");
      }
    }
    return colorList;
  }

  // setLineColor(){
  //   const from = this.props.eventPeriodFrom;
  //   const to = this.props.eventPeriodTo;
  //   let colorList = [];
  //   for (let i = 0; i < 24; i++) {
  //     if(from <= i && i <= to){
  //       colorList.push("rgba(244,16,124,0.8)");
  //     }else{
  //       colorList.push("rgba(244,16,124,0.3)");
  //     }
  //   }
  //   return colorList;
  // }

  render() {
    const {t} = this.props;
    
    const Error = () => (
      <div>
        {(() => {
          return (
            <Alert bsStyle="danger">
              <p>{t("Message." + msgs["msg_common_01"])}</p>
            </Alert>
          );
        })()}
      </div>
    );

    const setData = () => {
      var distance_label = t('Common.Distance')
      var event_count_label = t('Common.EventCount')
      return {
        labels: ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00',
          '12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
        datasets: [
          // {
          //   type: "line",
          //   label: distance_label,
          //   borderColor: "rgba(244,16,124,0.8)",
          //   backgroundColor: this.setLineColor(),
          //   fill: false,
          //   lineTension: 0.1,
          //   pointRadius: 4,
          //   pointHoverRadius: 5,
          //   data: this.props.data.distanceForGraph,
          //   yAxisID: "y-axis-1",
          //   datalabels: {
          //     display:false
          //   }
          // },
          {
            type: "bar",
            label: event_count_label,
            borderColor: "rgba(57,57,205,0.5)",
            backgroundColor: this.setBarColor(),
            fill: false,
            borderWidth: 1,
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "rgba(244,16,124,0.3)",
            pointHoverBorderColor: "rgba(244,16,124,0.8)",
            data: this.props.data.countEventForGraph,
            yAxisID: "y-axis-2",
            datalabels: {
              display:false
            }
          },
        ],
      }
    }
    const chartOptions = {
      hover: {
        mode: "index",
        intersect: false,
      },
      scales: {
        // y軸の最小値、最大値を設定
        yAxes: [
          // {
          //   id: "y-axis-1",
          //   type: "linear",
          //   position: "right",
          //   scaleLabel: {  
          //     display: true, 
          //     labelString: 'km', 
          //     fontSize: 14
          // },
          //   ticks: {
          //     beginAtZero: true,
          //     min: 0,
          //   },
          // },
          {
            id: "y-axis-2",
            type: "linear",
            position: "left",
            ticks: {
              beginAtZero: true,
              min: 0,
            },
          },
        ],
        xAxes: [
          {
            // x軸のgrid線を非表示
            gridLines: {
              drawOnChartArea: false,
              offsetGridLines: true,
            },
          },
        ],
      },
      tooltips: {
        mode: "index",
        intersect: false,
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            let index = tooltipItem.datasetIndex;
            let data = chart.config.data.datasets[index];
            return {
              borderColor: data.borderColor,
              backgroundColor: data.backgroundColor,
            };
          },
        },
      },
      legend: {
        display: true,
      },
    };

    return (
      <Panel className="eventChartGraph">
        {
          // ローディング判定
          this.props.safetyMapLoading ? (
            <Loader />
          ) : // データ取得判定
          this.props.isSafetyMap ? (
            <div>
              {/* <div className="mini-div" /> */}
              <Bar data={setData} options={chartOptions}/>
            </div>
          ) : (
            // 失敗
            <Error />
          )
        }
      </Panel>
    );
  }
}

export default withTranslation()(EventGraph);



// WEBPACK FOOTER //
// ./src/component/SafetyMap/EventGraph.js